<template>
	<Character
		class="enzo"
		v-bind="$attrs"
		title=""
		:content="content"
		:buttons="buttons"
		:position="position"
		:speaking="state === 'speaking'"
	>
		<VideoSequence
			v-model="state"
			:video-map="videos"
			:transitions="transitions"
			@ended="videoEndHandler"
			:muted="$store.state.sound.muted"
		/>
	</Character>
</template>

<script>
import characterMixins from "@/mixins/character.mixins";
import { isOneOf } from "@/lib/validators";
import { ENZO_COMPONENT_POSITIONS } from "@/constants";

export default {
	name: 'Enzo',
	mixins: [characterMixins],
	props: {
		videos: {
			type: Object,
			required: true,
		},
		content: {
			type: String,
			required: true,
		},
		transitions: {
			type: Object,
			required: false,
			default: () => ({
				entering: "speaking",
			}),
		},
		buttons: {
			type: Array,
			required: false,
			default: () => [],
		},
		position: {
			type: String,
			required: false,
			default: "bottom-left",
			validator: isOneOf(ENZO_COMPONENT_POSITIONS),
		},
	},
};
</script>

<style lang="scss" scoped>
	$enzo-video-width: 50vw;
	$enzo-extra-spacing: 10vw;
	$dialogue-offset-v: 40vh;
	$dialogue-offset-h: $enzo-video-width - $enzo-extra-spacing;

	.enzo {
		--character-width: #{$enzo-video-width};
		--dialogue-offset-v: #{$dialogue-offset-v};
		--dialogue-offset-h: #{$dialogue-offset-h};

		@include mobile {
			--character-width: #{$enzo-video-width / 1.5};
			--dialogue-offset-v: #{$dialogue-offset-v / 1.25};
			--dialogue-offset-h: #{$dialogue-offset-h / 1.4};
		}

		@include tablet {
			--character-width: #{$enzo-video-width / 1.3};
			--dialogue-offset-v: #{$dialogue-offset-v / 1.15};
			--dialogue-offset-h: #{$dialogue-offset-h / 1.4};
		}

		@include desktop-sm {
			--character-width: #{$enzo-video-width / 1.2};
			--dialogue-offset-v: #{$dialogue-offset-v / .85};
			--dialogue-offset-h: #{$dialogue-offset-h / 1.15};
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/partials/Enzo.vue